import css from 'styled-jsx/css';

const styles = css.global`#emp-garantia-carro-credito-seguro {
  padding: 32px 0;
  background: #FBFBFB;
}

#emp-garantia-carro-credito-seguro .ctn-home-24 {
  display: flex;
  flex-direction: column;
  gap: 32px;
  align-items: center;
}
#emp-garantia-carro-credito-seguro .credito-seguro-img {
  border-radius: 4px;
  width: 100%;
  max-width: 288px;
}

#emp-garantia-carro-credito-seguro .credito-seguro-titulo {
  margin: 0;
  color: #C00;
  font-family: "SantanderHeadline";
  font-size: 32px;
  font-style: normal;
  font-weight: 400;
  line-height: 48px;
}

#emp-garantia-carro-credito-seguro .credito-seguro-texto {
  margin-top: 16px;
  color: #444;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
}

#emp-garantia-carro-credito-seguro .credito-seguro-texto b {
  font-weight: 600;
}

#emp-garantia-carro-credito-seguro .credito-seguro-cards {
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

#emp-garantia-carro-credito-seguro .credito-seguro-card {
  display: flex;
  gap: 24px;
  align-items: center;
}

#emp-garantia-carro-credito-seguro .credito-seguro-card-texto {
  color: #444;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
}

#emp-garantia-carro-credito-seguro .credito-seguro-btn-simular {
  width: 100%;
  max-width: 272px;
  height: 48px;
  margin: 32px auto 0;
}

@media (min-width: 992px) {
  #emp-garantia-carro-credito-seguro {
    padding: 64px 0;
  }
  
  #emp-garantia-carro-credito-seguro .ctn-home-24 {
    flex-direction: row;
    gap: 72px;
  }

  #emp-garantia-carro-credito-seguro .credito-seguro-img {
    max-width: 525px;
  }

  #emp-garantia-carro-credito-seguro .credito-seguro-conteudo {
    max-width: 607px;
    width: 55%;
  }

  #emp-garantia-carro-credito-seguro .credito-seguro-titulo {
    font-size: 40px;
    line-height: 60px;
  }

  #emp-garantia-carro-credito-seguro .credito-seguro-cards {
    margin-top: 32px;
  }

  #emp-garantia-carro-credito-seguro .credito-seguro-btn-simular {
    margin: 32px 0 0;
  }
}`;

export default styles;